const RATE_LIMIT = 5
const RATE_WINDOW_MS = 60_000
const errorTimestamps: number[] = []

function isRateLimited(): boolean {
  const now = Date.now()
  // Remove timestamps outside the window
  while (errorTimestamps.length > 0 && errorTimestamps[0] < now - RATE_WINDOW_MS) {
    errorTimestamps.shift()
  }
  if (errorTimestamps.length >= RATE_LIMIT) return true
  errorTimestamps.push(now)
  return false
}

export function reportError(error: unknown, context?: Record<string, unknown>): void {
  if (import.meta.env.DEV) {
    console.error('[errorReporter]', error, context)
    return
  }

  if (isRateLimited()) return

  const payload = JSON.stringify({
    error_class: error instanceof Error ? error.constructor.name : 'UnknownError',
    message: error instanceof Error ? error.message : String(error),
    stack: error instanceof Error ? error.stack?.slice(0, 5000) : undefined,
    url: window.location.href,
    ...context,
  })

  // Use sendBeacon for reliability (survives page unload), with fetch fallback
  const url = '/api/v1/client_errors'
  const sent = navigator.sendBeacon?.(url, new Blob([payload], { type: 'application/json' }))
  if (!sent) {
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {
      // Silently fail — we can't report errors about error reporting
    })
  }
}

export function installGlobalErrorHandlers(): void {
  if (import.meta.env.DEV) return

  window.addEventListener('error', (event) => {
    reportError(event.error ?? event.message)
  })

  window.addEventListener('unhandledrejection', (event) => {
    reportError(event.reason)
  })
}
